import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ApexPage from './pages/ApexPage';
import BlackOpsPage from './pages/BlackOpsPage';
import TitanPage from './pages/TitanPage';
import LoginPage from './pages/LoginPage';
import PortalPage from './pages/PortalPage';
import AdminPage from './pages/AdminPage';
import SuccessPage from './pages/SuccessPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/apex" element={<ApexPage />} />
        <Route path="/blackops" element={<BlackOpsPage />} />
        <Route path="/titan" element={<TitanPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/portal" element={<PortalPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </Routes>
    </Router>
  );
}

export default App;